var isValidDrag = function isValidDrag(_ref) {
  var inside = _ref.inside,
      circleWidth = _ref.circleWidth,
      drag = _ref.drag,
      checked = _ref.checked,
      boxWidth = _ref.boxWidth;
  var difference = boxWidth - circleWidth;
  return checked ? !inside && -drag > difference / 2 : !inside && drag > boxWidth / 3;
};
var cleanDrag = function cleanDrag() {
  return {
    startPoint: null,
    isDragging: false
  };
}; // eslint-disable-next-line complexity

var calculateDrag = function calculateDrag(clientX, _ref2) {
  var startPoint = _ref2.startPoint,
      checked = _ref2.checked,
      isDragging = _ref2.isDragging,
      boxWidth = _ref2.boxWidth,
      circleWidth = _ref2.circleWidth;
  if (!isDragging) return null;
  var move = startPoint - clientX;
  var drag = !checked ? clientX - startPoint : boxWidth - circleWidth - move;
  if (!checked && clientX > 0 && clientX > startPoint && drag < boxWidth * 0.7) return drag;
  if (checked && clientX > 0 && clientX < startPoint && move < boxWidth * 0.7) return drag;
  return null;
};
var dragStartingPoints = function dragStartingPoints(checked) {
  return function (_ref3) {
    var circleWidth = _ref3.circleWidth,
        boxWidth = _ref3.boxWidth;
    if (checked) return {
      drag: boxWidth - circleWidth
    };
    return {
      drag: 0
    };
  };
};

export { calculateDrag, cleanDrag, dragStartingPoints, isValidDrag };
//# sourceMappingURL=toggleHelper.js.map
